<ng-template #content let-modal>
    <div class="modal-header">
      <mat-card-title>Agregar motivo</mat-card-title>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-12 mb-3">
            <mat-form-field class="example-full-width" appearance="outline">
                <mat-label>Nombre</mat-label>
                <input matInput placeholder="Ingrese nombre del motivo" [(ngModel)]="motivoAdd.nombre" required>
              </mat-form-field>
        </div>
        <div class="col-12 mb-3">
          <mat-form-field class="example-full-width" appearance="outline">
              <mat-label>Descripcion</mat-label>
              <textarea id="textarea_descripcion" matInput placeholder="Ingrese la descripcion del motivo, la cual aparecerá en el documento" 
                (keyup)="changeDescripcion()" (click)="changeDescripcion()" cols="2" rows="10" [(ngModel)]="motivoAdd.descripcion" [matAutocomplete]="auto"></textarea>
              <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event)" 
                (keydown.up)="$event.stopPropagation()" (keydown.down)="$event.stopPropagation()">
                <mat-option disabled>VARIABLES</mat-option>
                <mat-option *ngFor="let variable of variables" [value]="variable.nombre">
                  {{variable.nombre}}: {{variable.descripcion}}
                </mat-option>
              </mat-autocomplete>
          </mat-form-field>
          <mat-hint>
            <b>VARIABLES</b>: Al escribir en el campo de texto, se mostrará una lista de variables las cuales se 
            pueden ocupar para mostrar informacion del trabajador para crear la carta de amonestacion de forma dinámica
          </mat-hint>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button mat-raised-button color="primary" (click)="AgregarMotivo()">Crear motivo</button>
    </div>
  </ng-template>
  
  <button mat-raised-button (click)="open(content)" color="primary">
    <mat-icon>add</mat-icon>
    Agregar motivo
  </button>